module.exports = __webpack_public_path__ + "static/media/Shells_Happy_Shells_Guy.fe108d83.png";